import { UPDATE_PERSONAL } from "./actionTypes";

export const updatePersonal = (payLoad, callback = () => {}) => ({
  type: UPDATE_PERSONAL,
  payLoad,
  callback,
});
